var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile__chat"},[(_vm.isAuth)?_c('Chat',{attrs:{"alwaysOpen":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }